import { types } from "../actions/types";

const initialState = {
    country_code: "",
    country_name: "",
    city: "",
    postal: null,
    latitude: null,
    longitude: null,
    IPv4: "",
    state: "",
};

export const geolocationReducer = (state = initialState, action) => {
    const { type = '' } = action;

    if (type === types.updateGeolocation) {
        return { ...state, ...action.payload };
    }

    return state;
};
